import { enUS as enLocalText, huHU as huLocaleTest } from '@mui/x-date-pickers/locales';
import { hu as huAdapterLocale, enUS as enAdapterLocale } from 'date-fns/locale';

export const getDateLocaleText = (language: string) =>
  language === 'hu' ? huLocaleTest : enLocalText;

export const getDateAdapterLocale = (language: string) =>
  language === 'hu' ? huAdapterLocale : enAdapterLocale;
